import { Component, NgZone, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-navbar-user',
  templateUrl: './user-navbar.component.html',
  styleUrls: ['./user-navbar.component.scss']
})
export class UserNavbarComponent {
  toggleClass = 'ft-maximize';
  placement = 'bottom-right';
  public isCollapsed = true;
  @Output()
  page = new EventEmitter();
  constructor(
    private authService: AuthService,
    public router: Router,
    private translateService: TranslateService,
    private ngZone: NgZone
  ) {}

  logout() {
    this.authService.signout();
  }

  ChangeLanguage(language: string) {
    this.translateService.use(language);
    // console.log(this.translateService.currentLang);
    this.ngZone.run(() => {});
  }

  ToggleClass() {
    if (this.toggleClass === 'ft-maximize') {
      this.toggleClass = 'ft-minimize';
    } else {
      this.toggleClass = 'ft-maximize';
    }
  }
  goTo(part: string, param) {
    console.log(part, param);
    this.router.navigate(
      [part, param]
      // { skipLocationChange: true }
    );
  }

  changPage(value) {
    console.log(value);
    this.page.emit(value);
  }
}
